export const SYSTEM_ADMIN = 'SYSTEM_ADMIN';

export const GOODIN_PLANNING = 'GOODIN_PLANNING';
export const GOODIN_PRODUCTION = 'GOODIN_PRODUCTION';
export const GOODIN_ARCHIVE = 'GOODIN_ARCHIVE';
export const GOODIN_IMPORT_LOG = 'GOODIN_IMPORT_LOG';
